import { render, staticRenderFns } from "./CampoUnidadNegocio.vue?vue&type=template&id=79da78ce"
import script from "./CampoUnidadNegocio.vue?vue&type=script&lang=js"
export * from "./CampoUnidadNegocio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports